<div [ngClass]="dialogBox ? 'card dialog-box' : ''">
  @if (dialogBox) {
    <div class="card-header">
      Date Range
      <span class="float-end" (click)="onDismiss()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
  }

  @if (errorMessage) {
    <div class="alert alert-danger" role="alert">
      {{ errorMessage }}
    </div>
  }
  @if (showDateOnly) {
    <div class="row row-cols-1 row-cols-lg-2 g-3 mb-2">
      <div class="form-floating">
        <input
          id="startDay"
          class="form-control"
          type="date"
          placeholder="Pick Date"
          [(ngModel)]="startDateTime"
          (change)="emitDateTime()"
        /><label for="startDay"> Start</label>
      </div>

      <div class="form-floating">
        <input
          id="endDay"
          type="date"
          class="form-control"
          placeholder="Pick Date"
          [(ngModel)]="endDateTime"
          [disabled]="!startDateTime"
          [min]="startDateTime"
          (change)="emitDateTime()"
        /><label for="endDay"> End</label>
      </div>
    </div>
  } @else {
    <div class="small mx-2">Time of day presets</div>
    <div class="d-flex gap-2 my-2">
      @for (time of timeSelectValues; track time) {
        <div>
          <button class="btn btn-outline-primary" (click)="updateTime(time)">
            {{ time?.value }}
          </button>
        </div>
      }
    </div>

    <div class="row row-cols-1 row-cols-lg-2 g-3 mb-2">
      <div class="form-floating">
        <input
          id="startDay"
          class="form-control"
          type="datetime-local"
          placeholder="Pick Date & Time"
          [(ngModel)]="startDateTime"
          (change)="emitDateTime()"
        /><label for="startDay"> Start</label>
      </div>

      <div class="form-floating">
        <input
          id="endDay"
          type="datetime-local"
          class="form-control"
          placeholder="Pick Date & Time"
          [(ngModel)]="endDateTime"
          [disabled]="!startDateTime"
          [min]="startDateTime"
          (change)="emitDateTime()"
        /><label for="endDay"> End</label>
      </div>
    </div>
  }
  <div class="d-flex gap-2 flex-wrap">
    @for (date of dateSelectValues; track date) {
      <div>
        <button class="btn btn-outline-primary" (click)="updateDate(date?.key)">
          {{ date?.value }}
        </button>
      </div>
    }
  </div>
  @if (dialogBox) {
    <div class="row row-cols-2 pt-4">
      <div class="col">
        <button (click)="onDismiss()" class="btn btn-dark btn-lg w-100">
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary w-100 btn-lg"
          (click)="saveDateRange()"
          [disabled]="!(endDateTime && startDateTime)"
        >
          Apply
        </button>
      </div>
    </div>
  }
</div>
